import { default as _91_46_46_46cms_93iv75zElaJqMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93PSX0hcuWmMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/3d-projects/[...slug].vue?macro=true";
import { default as index4YDuRItkn5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93oLlF4pODs5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/akcii/[...slug].vue?macro=true";
import { default as indexS7TnmfIVM6Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93itgrGLXnuQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/articles/[...slug].vue?macro=true";
import { default as indexFE12DDP5NaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/articles/index.vue?macro=true";
import { default as indexSsklCL5Hh2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/authorization/index.vue?macro=true";
import { default as indexftICMiIdfNMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_937HZK44w2jyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93aupP5E59eKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalog/[...slug].vue?macro=true";
import { default as indexSGCgmvN1YyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93vy2giihWNRMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultOjX9OcxzXuMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalogsearch/result.vue?macro=true";
import { default as indexdU4V9PcOLpMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93AVPSk0mQvFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_936wQrGUe7XSMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/fabriki/[...slug].vue?macro=true";
import { default as indexaamPyR2pwfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93N5Pumyu1SXMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93VNAEFkkQcvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/product/[...slug].vue?macro=true";
import { default as indexdItsltfaejMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/profile/index.vue?macro=true";
import { default as indexovk0IjQfA5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/profile/orders/index.vue?macro=true";
import { default as indexC96hyk2ZEgMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93PXuVGhe8gcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/sets/[...slug].vue?macro=true";
import { default as indexSLKtwdUJAYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93iv75zElaJqMeta?.name ?? "cms",
    path: _91_46_46_46cms_93iv75zElaJqMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93iv75zElaJqMeta || {},
    alias: _91_46_46_46cms_93iv75zElaJqMeta?.alias || [],
    redirect: _91_46_46_46cms_93iv75zElaJqMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93PSX0hcuWmMMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93PSX0hcuWmMMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93PSX0hcuWmMMeta || {},
    alias: _91_46_46_46slug_93PSX0hcuWmMMeta?.alias || [],
    redirect: _91_46_46_46slug_93PSX0hcuWmMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index4YDuRItkn5Meta?.name ?? "3d-projects",
    path: index4YDuRItkn5Meta?.path ?? "/3d-projects",
    meta: index4YDuRItkn5Meta || {},
    alias: index4YDuRItkn5Meta?.alias || [],
    redirect: index4YDuRItkn5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93oLlF4pODs5Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93oLlF4pODs5Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93oLlF4pODs5Meta || {},
    alias: _91_46_46_46slug_93oLlF4pODs5Meta?.alias || [],
    redirect: _91_46_46_46slug_93oLlF4pODs5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexS7TnmfIVM6Meta?.name ?? "akcii",
    path: indexS7TnmfIVM6Meta?.path ?? "/akcii",
    meta: indexS7TnmfIVM6Meta || {},
    alias: indexS7TnmfIVM6Meta?.alias || [],
    redirect: indexS7TnmfIVM6Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93itgrGLXnuQMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93itgrGLXnuQMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93itgrGLXnuQMeta || {},
    alias: _91_46_46_46slug_93itgrGLXnuQMeta?.alias || [],
    redirect: _91_46_46_46slug_93itgrGLXnuQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexFE12DDP5NaMeta?.name ?? "articles",
    path: indexFE12DDP5NaMeta?.path ?? "/articles",
    meta: indexFE12DDP5NaMeta || {},
    alias: indexFE12DDP5NaMeta?.alias || [],
    redirect: indexFE12DDP5NaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexSsklCL5Hh2Meta?.name ?? "authorization",
    path: indexSsklCL5Hh2Meta?.path ?? "/authorization",
    meta: indexSsklCL5Hh2Meta || {},
    alias: indexSsklCL5Hh2Meta?.alias || [],
    redirect: indexSsklCL5Hh2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexftICMiIdfNMeta?.name ?? "cart",
    path: indexftICMiIdfNMeta?.path ?? "/cart",
    meta: indexftICMiIdfNMeta || {},
    alias: indexftICMiIdfNMeta?.alias || [],
    redirect: indexftICMiIdfNMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_937HZK44w2jyMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_937HZK44w2jyMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_937HZK44w2jyMeta || {},
    alias: _91_46_46_46id_937HZK44w2jyMeta?.alias || [],
    redirect: _91_46_46_46id_937HZK44w2jyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93aupP5E59eKMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93aupP5E59eKMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93aupP5E59eKMeta || {},
    alias: _91_46_46_46slug_93aupP5E59eKMeta?.alias || [],
    redirect: _91_46_46_46slug_93aupP5E59eKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexSGCgmvN1YyMeta?.name ?? "catalog",
    path: indexSGCgmvN1YyMeta?.path ?? "/catalog",
    meta: indexSGCgmvN1YyMeta || {},
    alias: indexSGCgmvN1YyMeta?.alias || [],
    redirect: indexSGCgmvN1YyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93vy2giihWNRMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93vy2giihWNRMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93vy2giihWNRMeta || {},
    alias: _91_46_46_46slug_93vy2giihWNRMeta?.alias || [],
    redirect: _91_46_46_46slug_93vy2giihWNRMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultOjX9OcxzXuMeta?.name ?? "catalogsearch-result",
    path: resultOjX9OcxzXuMeta?.path ?? "/catalogsearch/result",
    meta: resultOjX9OcxzXuMeta || {},
    alias: resultOjX9OcxzXuMeta?.alias || [],
    redirect: resultOjX9OcxzXuMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexdU4V9PcOLpMeta?.name ?? "clear-page-slider",
    path: indexdU4V9PcOLpMeta?.path ?? "/clear-page-slider",
    meta: indexdU4V9PcOLpMeta || {},
    alias: indexdU4V9PcOLpMeta?.alias || [],
    redirect: indexdU4V9PcOLpMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93AVPSk0mQvFMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93AVPSk0mQvFMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93AVPSk0mQvFMeta || {},
    alias: _91_46_46_46slug_93AVPSk0mQvFMeta?.alias || [],
    redirect: _91_46_46_46slug_93AVPSk0mQvFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_936wQrGUe7XSMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_936wQrGUe7XSMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_936wQrGUe7XSMeta || {},
    alias: _91_46_46_46slug_936wQrGUe7XSMeta?.alias || [],
    redirect: _91_46_46_46slug_936wQrGUe7XSMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexaamPyR2pwfMeta?.name ?? "fabriki",
    path: indexaamPyR2pwfMeta?.path ?? "/fabriki",
    meta: indexaamPyR2pwfMeta || {},
    alias: indexaamPyR2pwfMeta?.alias || [],
    redirect: indexaamPyR2pwfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93N5Pumyu1SXMeta?.name ?? "order-status-hash",
    path: _91hash_93N5Pumyu1SXMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93N5Pumyu1SXMeta || {},
    alias: _91hash_93N5Pumyu1SXMeta?.alias || [],
    redirect: _91hash_93N5Pumyu1SXMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93VNAEFkkQcvMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93VNAEFkkQcvMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93VNAEFkkQcvMeta || {},
    alias: _91_46_46_46slug_93VNAEFkkQcvMeta?.alias || [],
    redirect: _91_46_46_46slug_93VNAEFkkQcvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexdItsltfaejMeta?.name ?? "profile",
    path: indexdItsltfaejMeta?.path ?? "/profile",
    meta: indexdItsltfaejMeta || {},
    alias: indexdItsltfaejMeta?.alias || [],
    redirect: indexdItsltfaejMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexovk0IjQfA5Meta?.name ?? "profile-orders",
    path: indexovk0IjQfA5Meta?.path ?? "/profile/orders",
    meta: indexovk0IjQfA5Meta || {},
    alias: indexovk0IjQfA5Meta?.alias || [],
    redirect: indexovk0IjQfA5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexC96hyk2ZEgMeta?.name ?? "recently",
    path: indexC96hyk2ZEgMeta?.path ?? "/recently",
    meta: indexC96hyk2ZEgMeta || {},
    alias: indexC96hyk2ZEgMeta?.alias || [],
    redirect: indexC96hyk2ZEgMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93PXuVGhe8gcMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93PXuVGhe8gcMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93PXuVGhe8gcMeta || {},
    alias: _91_46_46_46slug_93PXuVGhe8gcMeta?.alias || [],
    redirect: _91_46_46_46slug_93PXuVGhe8gcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexSLKtwdUJAYMeta?.name ?? "wishlist",
    path: indexSLKtwdUJAYMeta?.path ?? "/wishlist",
    meta: indexSLKtwdUJAYMeta || {},
    alias: indexSLKtwdUJAYMeta?.alias || [],
    redirect: indexSLKtwdUJAYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260928063828/pages/wishlist/index.vue").then(m => m.default || m)
  }
]